const featureNames = Object.freeze({
  ACQUISITION_BOOSTER: 'acquisition-booster',
  AD_MATERIALS: 'ad-materials',
  APP_HEADER: 'app-header',
  AI_SETTINGS: 'ai-settings',
  ASSISTED_ONBOARDING: 'assisted-onboarding',
  ONBOARDING_WEB_SCRAPING: 'onboarding-web-scraping',
  APP_BRANDING: 'app-branding',
  ASSIGN_LEADS: 'assign-leads',
  AUTHORIZATION: 'authorization',
  LEAD_AI_SUMMARY: 'lead-ai-summary',
  AVV: 'avv',
  BILLWERK: 'billwerk',
  WEBSITE_SCRAPE: 'website-scrape',
  CAMPAIGN: 'campaign',
  CAROUSEL_POSTS: 'carousel-posts',
  CHANGE_SUBSCRIPTION: 'change-subscription',
  CMS: 'cms',
  CONNECTION_MANAGER: 'connection-manager',
  CONNECTION_MANAGER_IMPORT_EXPORT: 'connection-manager-import-export',
  COMPANY_USER: 'company-user',
  COMPANY: 'company',
  CONSULTING: 'consulting',
  CONTACTS: 'contacts',
  CONTENT_CREATOR: 'content-creator',
  MARKETING_AGENT: 'marketing-agent',
  CONTRACT: 'contract',
  CRM: 'crm',
  CASAONE: 'casaone',
  PROPSTACK_MULTI_COMPANY: 'propstack-multi-company',
  DASHBOARD_PRESENTATION: 'dashboard-presentation',
  DASHBOARD_TIME_FILTER: 'dashboard-time-filter',
  DATA_PRIVACY: 'data-privacy',
  DELETE_CONTACT: 'delete-contact',
  DELETE_LEADS: 'delete-leads',
  EVENT_CALENDAR: 'event-calendar',
  FEEDBACK_TICKET: 'feedback-ticket',
  HELPCENTER: 'helpcenter',
  HOPPERMATION: 'hoppermation',
  I18N: 'i18n',
  IUBENDA: 'iubenda',
  LANDINGPAGE_NAVIGATION: 'landingpage-navigation',
  LANDINGPAGE: 'landingpage',
  LEAD_EXPORT: 'lead-export',
  LEAD_IMPORT: 'lead-import',
  LEAD_CHANNEL_PAUSE_STOP: 'lead-channel-pause-stop',
  LEAD: 'lead',
  LEGAL_CONSENTS: 'legal-consents',
  LICENSE_AGREEMENT: 'license-agreement',
  MAKLER_MITTEL: 'makler-mittel',
  MATERIAL_GUIDE: 'material-guide',
  NEWSFLASH: 'newsflash',
  NOTIFICATIONS: 'notifications',
  NEXT_EMAILS: 'next-emails',
  ONBOARDING_PREVIEW: 'onboarding-preview',
  PARTNER: 'partner',
  PERFORMANCE_MARKETING: 'performance-marketing',
  PLOT_VALUATION: 'lp-grundstuecksbewertung',
  POSTAL_SHIPPING: 'postal-shipping',
  PRODUCTFRUITS: 'productfruits',
  PROPSTACK_GROUP_FILTER: 'propstack-group-filter',
  REGENERATION: 'regeneration',
  REGISTER: 'register',
  RETURNCALL_TOPICS: 'returncall-topics',
  SIGNUP: 'signup',
  SSO: 'sso',
  STATIC_CAMPAIGN: 'static-campaign',
  STATISTIC_DASHBOARD: 'statistic-dashboard',
  SUPPORT_CONTACT: 'support-contact',
  TEXT_AI_TOPICS: 'text-ai-topics',
  TOPIC: 'topic',
  TOPIC_SETTINGS: 'topic-settings',
  USAGE_COUNTER: 'usage-counter',
  VALUATION: 'valuation',
  HUBSPOT_CHAT: 'hubspot-chat',
  LIVE_CHAT_APP_BAR: 'live-chat-app-bar',
  IMAGE_EDIT: 'image-edit',
  AD_MATERIALS_UPLOAD: 'ad-materials-upload',
  AD_MATERIALS_EDIT: 'ad-materials-edit',
  AD_MATERIALS_DELETE: 'ad-materials-delete',
  /** Connection Manager Google Calendar tile and setup dialog only. */
  GOOGLE_CALENDAR: 'google-calendar',
  /** Profile settings → Calendar sync card only (not Connection Manager). */
  GOOGLE_CALENDAR_SETTINGS: 'google-calendar-settings',
  GOOGLE_REVIEW: 'google-review',
  GOOGLE_REVIEW_TARGET_LINK: 'google-review-target-link',
  PROVEN_EXPERT: 'proven-expert',
  KONSTANTINE: 'konstantine',
  POST_METRICS: 'post-metrics',
})

export default featureNames
